import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M18 6V12H7.83L10.41 9.41L9 8L4 13L9 18L10.41 16.59L7.83 14H20V6H18Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "LineBreak"
);
